import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PageMenu from "../../../blocks/PageMenu/PageMenu";
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import useDecode from "hooks/useDecode";
import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';
import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import useGetInfoDeclaracionSituacionActividad from "services/record/DeclaracionSituacionActividad/useGetInfoDeclaracionSituacionActividad";
import useGetDeclaracionSituacionActividadByID from "services/record/DeclaracionSituacionActividad/useGetDeclaracionSituacionActividadByID";
import useGetDeclaracionSituacionActividadByUser from "services/record/DeclaracionSituacionActividad/useGetDeclaracionSituacionActividadByUser";
import DeclaracionSituacionActividad from "./DeclaracionSituacionActividad";

const GridDeclaracionSituacionActividad = ({ expedienteId = null, origen = null }) => {

    const {
        getDeclaracionSituacionActividadByID,
        loadingGetDeclaracionSituacionActividadByID,
        statusGetDeclaracionSituacionActividadByID
    } = useGetDeclaracionSituacionActividadByID();

    const {
        getInfoDeclaracionSituacionActividad,
        loadingGetInfoDeclaracionSituacionActividad,
        statusGetInfoDeclaracionSituacionActividad
    } = useGetInfoDeclaracionSituacionActividad();

    const {
        dataGetDeclaracionSituacionActividadByUser,
        getDeclaracionSituacionActividadByUser,
        loadingGetDeclaracionSituacionActividadByUser,
        statusGetDeclaracionSituacionActividadByUser
    } = useGetDeclaracionSituacionActividadByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = 'Declaración de situación de actividad';
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    ////////////////////////////////////////
    // Carga inicial
    ////////////////////////////////////////
    useEffect(() => {
        getDeclaracionSituacionActividadByUser(userId, expedienteIdByOrigen);
    }, []);

    ////////////////////////////////////////
    // Unificación HTTP
    ////////////////////////////////////////
    useEffect(() => {
        if (statusGetDeclaracionSituacionActividadByID?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionSituacionActividadByID.status,
                statusText: statusGetDeclaracionSituacionActividadByID.statusText
            });
        } else if (statusGetInfoDeclaracionSituacionActividad?.status) {
            setCurrentHttp({
                status: statusGetInfoDeclaracionSituacionActividad.status,
                statusText: statusGetInfoDeclaracionSituacionActividad.statusText
            });
        } else if (statusGetDeclaracionSituacionActividadByUser?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionSituacionActividadByUser.status,
                statusText: statusGetDeclaracionSituacionActividadByUser.statusText
            });
        }
    }, [
        statusGetDeclaracionSituacionActividadByID,
        statusGetInfoDeclaracionSituacionActividad,
        statusGetDeclaracionSituacionActividadByUser
    ]);

    ////////////////////////////////////////
    // Selección fila
    ////////////////////////////////////////
    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getDeclaracionSituacionActividadByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    ////////////////////////////////////////
    // Generar formulario
    ////////////////////////////////////////
    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoDeclaracionSituacionActividad(userId, expedienteIdByOrigen, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    ////////////////////////////////////////
    // Mostrar botón generar
    ////////////////////////////////////////
    useEffect(() => {
        const arrData = dataGetDeclaracionSituacionActividadByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 99);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetDeclaracionSituacionActividadByUser]);

    ////////////////////////////////////////
    // Loader unificado
    ////////////////////////////////////////
    const isLoading = () => {
        return (
            loadingGetDeclaracionSituacionActividadByID ||
            loadingGetInfoDeclaracionSituacionActividad ||
            (loadingGetDeclaracionSituacionActividadByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetDeclaracionSituacionActividadByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {/* SUCCESS */}
            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <DeclaracionSituacionActividad
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getDeclaracionSituacionActividadByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {/* ERROR */}
            {currentHttp.status && !isLoading() && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridDeclaracionSituacionActividad;